import jwt_decode from "jwt-decode";

const ID_TOKEN_KEY = "id_token" as string;

/**
 * @description get token form localStorage
 */
export const getToken = (): string | null => {
  return window.localStorage.getItem(ID_TOKEN_KEY);
};

export const getDecodedToken = (): string | null => {
  const jwt = window.localStorage.getItem(ID_TOKEN_KEY);
  if (jwt !== null) {
    try {
      return jwt_decode(jwt);
    } catch (e) {
      return null;
    }
  } else {
    return null;
  }
};

/**
 * @description true when a signed-in session's token is stored and hasn't expired. The token is
 * only saved once sign-in is complete (after the MFA code when MFA is on).
 */
export const hasLiveToken = (): boolean => {
  const decoded = getDecodedToken() as { exp?: number } | null;
  if (!decoded) return false;
  return !decoded.exp || decoded.exp * 1000 > Date.now();
};

/**
 * @description save token into localStorage
 * @param token: string
 */
export const saveToken = (token: string): void => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};

/**
 * @description remove token form localStorage
 */
export const destroyToken = (): void => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
};

export default {
  getToken,
  saveToken,
  destroyToken,
  getDecodedToken,
  hasLiveToken,
};
